export function validatePhoneNumbers(nuTelefone: string | string[] | null) {
	if (nuTelefone === null) {
		return null;
	}
	if (Array.isArray(nuTelefone)) {
		return nuTelefone;
	}
	return [nuTelefone];
}
